const STORAGE_KEY_REDIRECT_PATH = "redirect_path";

export const setRedirectPath = (redirectPath: string) => {
    if (redirectPath) {
        globalThis.sessionStorage.setItem(STORAGE_KEY_REDIRECT_PATH, redirectPath);
    } else {
        removeRedirectPath();
    }
};

export const getRedirectPath = () => {
    return globalThis.sessionStorage.getItem(STORAGE_KEY_REDIRECT_PATH);
};

export const removeRedirectPath = () => {
    globalThis.sessionStorage.removeItem(STORAGE_KEY_REDIRECT_PATH);
};
